import axiosInstance from '../api/axiosInstance';

const ENDPOINTS = {
  GET_ALL_GROUPS: '/GetSSSs',
  CREATE_GROUP: '/CreateSSS',
  DELETE_GROUP: '/SSSDelete',
  UPDATE_GROUP: '/UpdateSSS'
};

export const getAllSSSs = async () => {
  try {
    const response = await axiosInstance.get(ENDPOINTS.GET_ALL_GROUPS);
    if (response.data && response.data.status === 200) {
      const users = response.data.data;
      if (Array.isArray(users)) {
        return users;
      }
    }
    return [];
  } catch (error) {
    console.error('Failed to fetch users:', error);
    throw error;
  }
};

export const CreateSSS = async (userData) => {
  try {
    const formData = new FormData();
    formData.append('Soru', userData.soru);   
    formData.append('Cevap', userData.cevap);
    formData.append('Sira', userData.sira);

    const response = await axiosInstance.post(ENDPOINTS.CREATE_GROUP, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    if (response.data && response.data.status === 200) {
      return response.data;
    }
    throw new Error(response.data.message || 'Failed to create user');
  } catch (error) {
    console.error('Create user error:', error);
    throw error;
  }
};

export const deleteSss = async (userId) => {
  try {
    const response = await axiosInstance.delete(`${ENDPOINTS.DELETE_GROUP}/${userId}`);
    if (response.data && response.data.status === 200) {
      return 1;
    }
    return 0;
  } catch (error) {
    return 0;
  }
};

export const updateSss = async (userId, userData) => {
  try {
    const formData = new FormData();
    formData.append('Soru', userData.soru);   
    formData.append('Cevap', userData.cevap);
    formData.append('Sira', userData.sira);

    const response = await axiosInstance.put(`${ENDPOINTS.UPDATE_GROUP}/${userId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    if (response.data && response.data.status === 200) {
      return response.data;
    }
    throw new Error(response.data.message || 'Failed to update user');
  } catch (error) {
    console.error('Update user error:', error);
    throw error;
  }
};
